// RsiWidget/RsiFetcher.js
// Singleton — does exactly 1 thing: raw I/O via HistoryService. No mapping, no business logic.
import historyService from '../../../services/HistoryService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'RsiFetcher';

class RsiFetcher extends CoreBase {
    _name = _name;

    /**
     * Fetches the RSI slots for ALL assets AND ALL periods in one call (sid=0, period=0).
     * @returns {Promise<{rk:string,root:string,sid:number,avgGain:number,avgLoss:number,value:number,price:number,ems:number}[]>}
     */
    fetchAll = async () => {
        try {
            const res = await historyService.getRsi(0, 0);
            return res?.data?.items ?? [];
        } catch (error) {
            this.logError('fetchAll', error.message);
            return [];
        }
    };
}

const rsiFetcher = new RsiFetcher();
export default rsiFetcher;
